import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "ba4be200-eb50-4d12-8372-c175d09f2c57", content: "2nd order low-pass filter", options: {} },
  { id: "e47ed078-0b56-47b6-aa85-2d8d46f6b5bd", content: "4th order low-pass filter", options: {} },
  { id: "82b5cf03-6efd-4b84-8359-2c77262ba09e", content: "2nd order band-pass filter", options: {} },
  { id: "df3f364b-fc59-4c0f-b1f8-fb0b46bd550e", content: "4th order band-pass filter", options: {} },
  { id: "8414b1b9-55cd-46ae-bd0d-65da89745873", content: "2nd order high-pass filter", options: {} },
  { id: "fb7e92d5-a9ca-454f-baa5-83fa1fc28e3f", content: "4th order high-pass filter", options: {} },
];

export const task: Task = {
  id: "2fdce4c2-8a32-4e34-9056-60edf3bd6ff3",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["8414b1b9-55cd-46ae-bd0d-65da89745873"],
};
